import { Grid } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import { useParams } from "react-router-dom/cjs/react-router-dom"
import useLoadingStore from "../../stores/LoadingStore"
import Cabecalho from "../Cabecalho"
import { Loading } from "../RegistradorDePedidos"
import { CheckboxProvider } from "./componentes/CheckboxContext"
import { CardapioProvider } from "./componentes/CardapioContext"
import EdicaoEmMassa from "./componentes/EdicaoEmMassa"
import FichaTecnica from "./componentes/fihcaTecnica"
import HistoricoCardapio from "./componentes/HistoricoCardapio"
import ImportacaoExportacao from "./componentes/ImportacaoExportacao"
import Inusmos from "./componentes/Inusmos"
import NovaTelaProdutos from "./componentes/NovaTelaProdutos"

const useStyles = makeStyles(() => ({
    container: {
        display: "flex",
        justifyContent: "center",
    },
}))

export default function CardapioNovo({ estabelecimento }) {
    const classes = useStyles()
    const { tela } = useParams()

    return (
        <CardapioProvider estabelecimento={estabelecimento}>
            <Grid>
                <Loading />
                <Cabecalho pagina={"Edição de Cardápio"} telasEdicao />
                <div className={classes.container}>
                    {tela === "produtos" ? (
                        <NovaTelaProdutos />
                    ) : tela === "massa" ? (
                        <CheckboxProvider>
                            <EdicaoEmMassa />
                        </CheckboxProvider>
                    ) : tela === "insumos" ? (
                        <Inusmos />
                    ) : tela === "ficha-tecnica" ? (
                        <FichaTecnica />
                    ) : tela === "importar-exportar" ? (
                        <ImportacaoExportacao />
                    ) : tela === "historico" ? (
                        <HistoricoCardapio />
                    ) : null}
                </div>
            </Grid>
        </CardapioProvider>
    )
}
